import {
  createPatientTrackingCsvImportConfig,
  PatientsPage as SharedPatientsPage
} from '@jarvis/platform-ui';
import { patientTrackingImportApi } from '../../api/patientTrackingImport';
import { showErrorToast, showSuccessToast } from '../../notifications/toast';

const patientsCsvImport = createPatientTrackingCsvImportConfig(
  {
    title: 'Patients',
    intro:
      'Each patient row must include a pharmacy name or GUID. Import Covered Entities first if patients reference a home CE.',
    templateUrl: patientTrackingImportApi.patients.templateUrl,
    templateFileName: patientTrackingImportApi.patients.templateFileName,
    importCsv: patientTrackingImportApi.patients.importCsv,
    downloadTemplate: patientTrackingImportApi.patients.downloadTemplate
  },
  { showSuccess: showSuccessToast, showError: showErrorToast }
);

export function PatientsPage() {
  return <SharedPatientsPage csvImport={patientsCsvImport} stateStorageKey="webopsui:patients-grid" />;
}
